var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import apolloClient from 'app/domains/apollo';
import { RenderHtmlToPdfDocument } from './mutation.gql';
import { getCompanyId } from '../getCompanyId';
import { getDocumentRenderInput } from '../getDocumentRenderInput';
export function renderHtmlToPdf(options) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b;
        const { documentId, name } = options;
        const companyId = yield getCompanyId();
        const { content, logoUrl } = yield getDocumentRenderInput(documentId, true);
        const appUrl = (_b = (_a = process.env.RENDER_SERVICE_CSS_FILE_APP_URL) !== null && _a !== void 0 ? _a : process.env.APP_URL) !== null && _b !== void 0 ? _b : window.location.origin;
        const cssFileUrl = new URL('/public/pdf.css', appUrl).toString();
        const { data } = yield apolloClient.mutate({
            mutation: RenderHtmlToPdfDocument,
            variables: {
                name,
                content,
                logoUrl,
                companyId: companyId || '',
                cssFile: cssFileUrl,
            },
        });
        const { response } = data || {};
        const [fileToDownload] = response || [];
        const { signed } = fileToDownload || {};
        if (!(signed === null || signed === void 0 ? void 0 : signed.url)) {
            throw Error('No signed url returned from API');
        }
        return signed.url;
    });
}
